import React, { useEffect, useState } from "react";
import { useLang } from "../lib/lang-context";

export default function PromoBar() {
  const { t } = useLang();
  const messages = t.promoBar;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % messages.length), 5000);
    return () => clearInterval(id);
  }, [messages.length]);

  // Reset idx when language changes (messages.length is constant but content differs)
  useEffect(() => {
    setIdx(0);
  }, [messages]);

  return (
    <div
      data-testid="promo-bar"
      className="bg-[var(--icor-blue)] text-white text-xs sm:text-sm font-medium tracking-tight overflow-hidden relative"
      style={{ height: 36 }}
    >
      <div className="max-w-7xl mx-auto h-full px-6 lg:px-8 flex items-center justify-center">
        <span
          key={idx}
          data-testid={`promo-msg-${idx}`}
          className="block animate-fade-up text-center truncate"
        >
          {messages[idx]}
        </span>
      </div>
    </div>
  );
}
